import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    users: [],
    selectedUser: null,
    userRoles: [],
    bulkUploadResult: null,
    loading: false,
    searchLoading: false,
    error: null,
    lastUpdated: null
};

const userSlice = createSlice({
    name: 'user',
    initialState,
    reducers: {
        preRegisterSuccess(state, action) {
            state.loading = false;
            state.error = null;
            if (action.payload.user) {
                state.users = [...state.users, {
                    ...action.payload.user,
                    type: 'PRE_REGISTERED',
                    status: 'PRE_REGISTERED'
                }];
            }
        },

        bulkUploadSuccess: (state, action) => {
            state.bulkUploadResult = action.payload;
            state.loading = false;
            state.error = null;
        },

        clearBulkUploadResult: (state) => {
            state.bulkUploadResult = null;
        },

        usersSearched(state, action) {
            state.users = action.payload.users;
            state.lastUpdated = new Date().toISOString();
            state.searchLoading = false;
            state.error = null;
        },

        userRolesLoaded(state, action) {
            const { userId, roles } = action.payload;
            if (state.selectedUser?.id === userId) {
                state.userRoles = roles;
                state.selectedUser.roles = roles;
            }
        },

        roleAssigned(state, action) {
            const { userId, roleId } = action.payload;
            if (state.selectedUser?.id === userId) {
                if (!state.userRoles.includes(roleId)) {
                    state.userRoles.push(roleId);
                    state.selectedUser.roles = [...state.userRoles];
                }
            }
            state.lastUpdated = new Date().toISOString();
            state.loading = false;
            state.error = null;
        },

        roleRemoved(state, action) {
            const { userId, roleId } = action.payload;
            if (state.selectedUser?.id === userId) {
                state.userRoles = state.userRoles.filter(id => id !== roleId);
                state.selectedUser.roles = state.userRoles;
            }
            state.lastUpdated = new Date().toISOString();
            state.loading = false;
            state.error = null;
        },

        userSelected(state, action) {
            state.selectedUser = action.payload.user;
            state.userRoles = action.payload.user?.roles || [];
        },

        searchLoadingStarted(state) {
            state.searchLoading = true;
            state.error = null;
        },

        loadingStarted(state) {
            state.loading = true;
            state.error = null;
        },

        loadingStopped(state) {
            state.loading = false;
        },

        loadingFailed(state, action) {
            state.loading = false;
            state.searchLoading = false;
            state.error = action.payload.error;
        },

        reset() {
            return initialState;
        }
    }
});

export const userActions = userSlice.actions;
export const userReducer = userSlice.reducer;